export const SocialIcons = {
  twitter: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.537"
      height="17.922"
      viewBox="0 0 17.537 17.922"
    >
      <path
        id="logo"
        d="M10.437,7.589,16.965,0H15.418L9.75,6.589,5.222,0H0L6.847,9.964,0,17.922H1.547l5.986-6.959,4.781,6.959h5.222l-7.1-10.333ZM8.318,10.052,7.624,9.06,2.1,1.165H4.481L8.935,7.536l.694.992,5.79,8.282H13.043L8.318,10.052Z"
        fill="var(--wp--preset--color--primary)"
      />
    </svg>
  ),
  facebook: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.922"
      height="17.922"
      viewBox="0 0 17.922 17.922"
    >
      <path
        id="Subtraction_12"
        data-name="Subtraction 12"
        d="M9.573,17.922H.99A.99.99,0,0,1,0,16.934V.989A.991.991,0,0,1,.988,0H16.933a.99.99,0,0,1,.989.989V16.933a.99.99,0,0,1-.988.989h-4.56V10.991H14.71l.35-2.713H12.374V6.551c0-.791.228-1.318,1.341-1.318h1.424V2.813a19.251,19.251,0,0,0-2.087-.106,3.48,3.48,0,0,0-2.514.92,3.628,3.628,0,0,0-.965,2.656v2H7.246v2.713H9.573v6.931Z"
        fill="var(--wp--preset--color--primary)"
      />
    </svg>
  ),
  instagram: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.922"
      height="17.926"
      viewBox="0 0 17.922 17.926"
    >
      <path
        id="Subtraction_13"
        data-name="Subtraction 13"
        d="M8.983,17.926h0a52.049,52.049,0,0,1-6.043-.215A3.426,3.426,0,0,1,.3,15.1a16.182,16.182,0,0,1-.276-4.5c.013-.507.027-1.081.027-1.637,0-.736-.007-1.4-.013-1.989V6.933C0,3.777-.01,2.47,1.169,1.245A3.392,3.392,0,0,1,3.045.216,17.743,17.743,0,0,1,6.517,0C7.1,0,7.747.005,8.493.012l.321,0c.954.008,1.9.014,2.981.014h.1a16.612,16.612,0,0,1,2.613.079l.023,0a3.846,3.846,0,0,1,2.3,1.154A4.233,4.233,0,0,1,17.9,3.9c.023.28.024,9.83,0,10.117a4.336,4.336,0,0,1-.935,2.49,3.671,3.671,0,0,1-1.926,1.2A51.958,51.958,0,0,1,8.983,17.926Zm0-2.581c.227,0,.458,0,.681,0s.451,0,.675,0c2.11,0,4.072-.175,4.895-2.285a10.519,10.519,0,0,0,.348-3.66c0-.213,0-.434,0-.662,0-.255,0-.5,0-.717.012-2.195.02-3.645-1.11-4.774-1.032-1.031-2.4-1.113-4.073-1.113l-.659,0h0c-.244,0-.495,0-.754,0-.218,0-.439,0-.652,0s-.424,0-.633,0a9.34,9.34,0,0,0-3,.349A3.145,3.145,0,0,0,2.735,4.424a10.528,10.528,0,0,0-.348,3.671q0,.314,0,.651,0,.274,0,.544a11.615,11.615,0,0,0,.348,3.778A3.142,3.142,0,0,0,4.7,15a9.339,9.339,0,0,0,3,.349c.209,0,.424,0,.632,0h0C8.55,15.347,8.768,15.345,8.985,15.345Zm1.5-1.181c-.232,0-.465,0-.713-.005s-.516-.006-.781-.006c-5.257,0-5.408-.152-5.408-5.41,0-2.7.11-4.016.759-4.7s1.773-.708,4.058-.71h.119c.33,0,.641,0,.941-.006.323,0,.628-.006.912-.006a11.1,11.1,0,0,1,1.982.126,2.23,2.23,0,0,1,1.251.613c.89.932.953,3.02.756,7.348C14.24,13.961,12.605,14.164,10.481,14.164ZM8.986,5.358a3.388,3.388,0,1,0,3.387,3.388A3.392,3.392,0,0,0,8.986,5.358Zm3.522-.926a.792.792,0,1,0,.791.792A.793.793,0,0,0,12.508,4.432ZM8.986,10.946a2.106,2.106,0,0,1-1.636-.688,2.368,2.368,0,0,1,0-3.024,2.108,2.108,0,0,1,1.637-.687,2.107,2.107,0,0,1,1.636.688,2.368,2.368,0,0,1,0,3.024A2.108,2.108,0,0,1,8.986,10.946Z"
        fill="var(--wp--preset--color--primary)"
      />
    </svg>
  ),
  linkedin: (
    <svg class="icon icon--linkedin" viewBox="0 0 24 24">
      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"></path>
    </svg>
  ),
  homesocial: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.922"
      height="17.922"
      viewBox="0 0 17.922 17.922"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_649"
            data-name="Rectangle 649"
            width="10.319"
            height="10.43"
            fill="#fff"
          />
        </clipPath>
      </defs>
      <g id="Group_829" data-name="Group 829" transform="translate(-276 -548)">
        <path
          id="Subtraction_18"
          data-name="Subtraction 18"
          d="M16.933,0H.988A.989.989,0,0,0,0,.989V16.934a.989.989,0,0,0,.989.988H16.933a.989.989,0,0,0,.989-.989h0V.988A.989.989,0,0,0,16.933,0Zm0,0"
          transform="translate(276 548)"
          fill="var(--wp--preset--color--primary)"
        />
        <g id="Group_741" data-name="Group 741" transform="translate(280 552)">
          <g id="Group_740" data-name="Group 740" clip-path="url(#clip-path)">
            <path
              id="Path_85"
              data-name="Path 85"
              d="M10.2,5.028,5.467.13a.427.427,0,0,0-.615,0L2.952,2.1a.238.238,0,0,1-.409-.166V1.464a.427.427,0,0,0-.427-.427H1.528a.427.427,0,0,0-.427.427V3.841a.428.428,0,0,1-.12.3l-.86.89a.427.427,0,0,0,.307.724H.673A.427.427,0,0,1,1.1,6.18V10a.427.427,0,0,0,.427.427H8.791A.427.427,0,0,0,9.218,10V6.18a.427.427,0,0,1,.427-.427h.245a.427.427,0,0,0,.307-.724"
              transform="translate(0 0)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
};
